import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Col, Form, Row, Collapse, Icon, Card, Breadcrumb } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import Container from '../../components/Container';
import yesBankWearableFaQ from './actions';
import { select_cardBlockJS } from '../NetworkCards/selectors';
import { constants } from '../../devUtils';
import StyledWearableFaq from './StyledWearableFaq';


const { Panel } = Collapse;

class WearableFaQs extends PureComponent {
  componentDidMount() {
    const { onyesBankWearableFaQ } = this.props;
    onyesBankWearableFaQ();
  }

  render() {
    const {
      isWearableFaqSuccessData: {
        faq = [],
      } = {},
    } = this.props;

    const halfLength = Math.ceil((faq && faq.length) / 2) || 0; // Get half length of the faqs

    const leftFaqs = faq.slice(0, halfLength); // Get the first half of the faqs
    const rightFaqs = faq.slice(halfLength); // Get the second half of the faqs

    const customExpandIcon = (panelProps) => {
      const { isActive } = panelProps;
      return isActive ? <Icon type="up" /> : <Icon type="down" />;
    };

    const LeftWearableFaq = () => (
      <Collapse
        accordion
        expandIconPosition="right"
        expandIcon={customExpandIcon}
        className="wearable-faq-collapse"
      >
        {leftFaqs && leftFaqs.map((item, index) => {
          const { que, ans } = item || {};
          if (!que || !ans) {
            return null;
          }
          return (
            <Panel
              isActive
              header={que}
              key={index.toString()}
            >
              <p>{ans}</p>
            </Panel>
          );
        })}
      </Collapse>
    );

    const RightWearableFaq = () => (
      <Collapse
        accordion
        expandIconPosition="right"
        expandIcon={customExpandIcon}
        className="wearable-faq-collapse"
      >
        {rightFaqs && rightFaqs.map((item, index) => {
          const { que, ans } = item || {};
          if (!que || !ans) {
            return null;
          }
          return (
            <Panel
              isActive
              header={que}
              key={index.toString()}
            >
              <p>{ans}</p>
            </Panel>
          );
        })}
      </Collapse>
    );

    return (
      <StyledWearableFaq>
        <Container>
          <h2 className="padding-t-2 nomargin-bottom">Manage Zaggle Cards</h2>
          <Breadcrumb separator="<" className="wearable-breadcrumb">
            <Breadcrumb.Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Breadcrumb.Item>
            <Breadcrumb.Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Breadcrumb.Item>
            <Breadcrumb.Item>FAQs</Breadcrumb.Item>
          </Breadcrumb>
          <Card className="rounded wearables-faq">
            <h2 className="margin-b-2">FAQs</h2>
            <Row type="flex" justify="start" align="top" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {LeftWearableFaq()}
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                {RightWearableFaq()}
              </Col>
            </Row>
            {faq.length === 0 && <p>No frequently asked questions found.</p>}
          </Card>
        </Container>
      </StyledWearableFaq>
    );
  }
}

WearableFaQs.propTypes = {
  isWearableFaqSuccessData: shape({}).isRequired,
  onyesBankWearableFaQ: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onyesBankWearableFaQ: (payload) => dispatch(yesBankWearableFaQ(payload)),
});

const mapStateToProps = createStructuredSelector({
  isWearableFaqSuccessData: select_cardBlockJS('isWearableFaqSuccess'),
});

const WearableFaQsWrapper = Form.create({ name: 'normal_admin' })(WearableFaQs);
export default connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(WearableFaQsWrapper));
export { WearableFaQs, WearableFaQsWrapper };



// WEBPACK FOOTER //
// client/containers/WearableFaQs/index.js